import { render, staticRenderFns } from "./LayoutMicroFront.vue?vue&type=template&id=4fd7e6e1&"
import script from "./LayoutMicroFront.vue?vue&type=script&lang=js&"
export * from "./LayoutMicroFront.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMicroFront.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports